module.exports = __webpack_public_path__ + "img/7.b5de16cc.svg";